module.exports = __webpack_public_path__ + "img/mock-pic3.52e55f70.png";